<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{hszn.hszn_zinn}} from the accommodation {{hszn.huis_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHszn">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../main";

export default {
  data() { 
    return {
      dialog: false,
      hszn_encrid: null,
      hszn: {}
    }
  },
  methods: {
    open(hszn_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hszn/getHszn.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHszn"
          },
          getHszn: {
            hszn_encrid: hszn_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hszn = res.data.getHszn;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHszn() { 
      this.$axios
        .post("ares/json/ares/huis/hszn/rmHszn.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHszn"
          },
          rmHszn: {
            hszn_encrid: this.hszn.hszn_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             //this.$router.reload('/huis/onHuis/' + res.data.rmHszn.huis_encrid); 
             // bus.$emit("closeDialog", "reload");
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHszn.text,
              color: res.data.rmHszn.color
            });
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    },
  }
}
</script>

